<script setup>
import Voucher from '@/components/cart/cartTotal/voucher/Voucher.vue'
import PostCode from '@/components/cart/postCode/PostCode.vue'
import { useRestoGLobalStore } from '@/stores/restoGlobalStore'
import { useCartGLobalStore } from '@/stores/cartGlobalStore'
import { CurrencyPoundIcon } from '@heroicons/vue/24/outline'

const restoStore = useRestoGLobalStore()
const cartStore = useCartGLobalStore()

// const handleOrderCheckOut = () => {
//   if (authStore.isLoggedIn) {
//     router.push({ name: 'order_options' })
//   } else {
//     // router.push({ name: 'login' })
//     router.push({ name: 'login', query: { redirect: '/resto/order_options' } })
//   }
// }
</script>
<template>
  <div class="p-3 rounded-lg bg-white dark:bg-gray-800/80 border border-gray-100 dark:border-gray-700 shadow-sm">
    <h3 class="font-bold text-lg mb-2 text-gray-900 dark:text-gray-100 flex items-center">
      <CurrencyPoundIcon class="h-5 w-5 mr-2 text-violet-600 dark:text-violet-500" />
      Order Summary
    </h3>
    
    <div
      v-if="cartStore?.CART_DATA?.promo_spend_discount_text"
      class="bg-gradient-to-r from-red-500 to-red-600 dark:from-indigo-700 dark:to-indigo-800 text-white rounded-md text-sm font-medium px-3 py-2 mb-4 shadow-sm transition-colors duration-200"
    >
      {{ cartStore?.CART_DATA?.promo_spend_discount_text }}
    </div>
    
    <div class="space-y-2">
      <div class="flex justify-between text-gray-900 dark:text-gray-100">
        <span class="text-sm lg:text-md">Subtotal</span>
        <span class="text-sm lg:text-md font-semibold">£{{ cartStore?.CART_DATA?.order_subtotal || 0.0 }}</span>
      </div>
      
      <div
        v-if="cartStore.CART_DATA?.order_offer_discount"
        class="flex justify-between text-gray-900 dark:text-gray-100"
      >
        <span class="text-sm lg:text-md">Offer Discount</span>
        <span class="text-sm lg:text-md text-red-700 dark:text-red-400 font-semibold"
          >£-{{ cartStore?.CART_DATA?.order_offer_discount || 0 }}</span
        >
      </div>
      
      <Voucher v-if="restoStore?.restoInfo?.is_voucher_available" class="my-3"></Voucher>
      
      <div class="flex justify-between text-gray-900 dark:text-gray-100">
        <span class="text-sm lg:text-md">Service Fee</span>
        <span class="text-sm lg:text-md">£{{ cartStore?.CART_DATA?.service_charge_fee || 0 }}</span>
      </div>
      
      <div
        v-if="cartStore.CART_DATA?.order_type == 'delivery'"
        class="flex justify-between text-gray-900 dark:text-gray-100"
      >
        <span class="text-sm lg:text-md">Delivery Fee</span>
        <span class="text-sm lg:text-md">£{{ cartStore?.CART_DATA?.delivery_charge || 0 }}</span>
      </div>
      
      <PostCode></PostCode>
    </div>
    
    <div class="mt-4 pt-3 border-t dark:border-gray-700">
      <div class="flex justify-between text-gray-900 dark:text-gray-100">
        <span class="text-base lg:text-lg font-bold">Total</span>
        <span class="text-base lg:text-lg font-bold">£{{ cartStore?.CART_DATA?.order_total || 0 }}</span>
      </div>
    </div>
    
    <!-- <div class="md:sticky bottom-0 w-full z-10 mx-auto bg-white">
      <button
        type="submit"
        :disabled="
          cartStore?.CAN_DO_CHECKOUT == 0 ||
          (cartStore?.CART_DATA?.order_type == 'delivery' && !cartStore?.CART_DATA?.pc_data?.is_valid)
        "
        class="w-full flex justify-between rounded-md border border-transparent bg-violet-700 py-2 px-4 text-base font-medium text-white shadow-sm hover:bg-e-violet focus:outline-none focus:ring-offset-gray-50 disabled:bg-gray-300 disabled:text-gray-400"
        @click="handleOrderCheckOut()"
      >
        <span>{{ cartStore?.CART_DATA?.order_total_item_quantity || 0 }}</span>
        <span>Go To Checkout</span>
        <span>£{{ cartStore?.CART_DATA?.order_total || 0 }}</span>
      </button>
    </div> -->
  </div>
</template>
